// src/pages/HomePage.js
import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import TrustStrip from '../components/sections/TrustStrip';
import ServicesSection from '../components/sections/ServicesSection';
import ExcellenceCenters from '../components/sections/ExcellenceCenters';
import DoctorsSection from '../components/sections/DoctorsSection';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import PatientJourney from '../components/sections/PatientJourney';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import InfrastructureSection from '../components/sections/InfrastructureSection';
import LocationsSection from '../components/sections/LocationsSection';
import EmergencyCTA from '../components/sections/EmergencyCTA';
import ResourcesSection from '../components/sections/ResourcesSection';

const HomePage = () => {
    return (
        <div style={{ paddingTop: '80px' }}>
            <HeroSection />
            <TrustStrip />
            <ServicesSection />
            <ExcellenceCenters />
            <DoctorsSection />
            <WhyChooseUs />
            <PatientJourney />
            <TestimonialsSection />
            <InfrastructureSection />
            <LocationsSection />
            <EmergencyCTA />
            <ResourcesSection />
        </div>
    );
};

export default HomePage;